import LOGO from "../images/Nogaleros.png";

export const Team__Nogaleros = {
  name: "Nogaleros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#333333",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 52 + 48 + 49,
  goalsScoredAgainst: 62 + 39 + 32,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
